import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import SectionWrapper from '../../components/marketing/SectionWrapper';

export default function PrivacyPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="pt-24 pb-14 bg-gradient-to-br from-cyan-50/60 via-white to-teal-50/40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-3 tracking-tight">{t('footer.privacy')}</h1>
          </motion.div>
        </div>
      </section>

      <SectionWrapper background="white">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="max-w-3xl mx-auto prose prose-gray prose-sm md:prose-base"
          dir="rtl"
        >
          <p className="text-gray-500 text-sm mb-6">עודכן לאחרונה: מרץ 2026</p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. כללי</h2>
          <p className="text-gray-600 leading-relaxed">
            קיפיקיד בע"מ ("החברה") מכבדת את פרטיות המשתמשים באתר ובמערכת קיפיקיד ("השירות").
            מדיניות פרטיות זו מפרטת את סוגי המידע שנאסף, אופן השימוש בו ודרכי ההגנה עליו.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. מידע שנאסף</h2>
          <p className="text-gray-600 leading-relaxed">
            במסגרת השימוש בשירות, אנו אוספים מידע אישי הכולל: שם מלא, מספר טלפון, כתובת דוא"ל,
            פרטי ילדים (שם, תאריך לידה, מידע רפואי רלוונטי), נתוני נוכחות ותמונות שהועלו למערכת.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. שימוש במידע</h2>
          <p className="text-gray-600 leading-relaxed">
            המידע משמש לתפעול השירות, כולל ניהול נוכחות, שליחת התראות להורים, ניהול תקציבי גנים
            ותקשורת בין צוות הגן להורים. לא נעשה שימוש מסחרי במידע האישי ולא נמסור אותו לצדדים שלישיים
            שלא לצורך אספקת השירות.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. שימוש בעוגיות וניטור</h2>
          <p className="text-gray-600 leading-relaxed">
            המשתמש מאשר שימוש בעוגיות (Cookies) וכלי ניטור כגון Google Analytics ודומיו.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. אבטחת מידע</h2>
          <p className="text-gray-600 leading-relaxed">
            החברה נוקטת באמצעי אבטחה מתקדמים להגנה על המידע, לרבות הצפנת נתונים, גישה מבוקרת
            ושמירה על שרתים מאובטחים בענן Azure של מיקרוסופט.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. זכויות המשתמש</h2>
          <p className="text-gray-600 leading-relaxed">
            כל משתמש רשאי לבקש עיון, תיקון או מחיקה של המידע האישי שלו. לפניות בנושא פרטיות ניתן
            לפנות אלינו בדוא"ל: info@kipikid.com או בטלפון: 050-5774499.
          </p>

          <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">7. שינויים במדיניות</h2>
          <p className="text-gray-600 leading-relaxed">
            החברה שומרת לעצמה את הזכות לעדכן מדיניות זו מעת לעת. שינויים מהותיים יפורסמו באתר
            ויישלח עדכון למשתמשים הרשומים.
          </p>
        </motion.div>
      </SectionWrapper>
    </>
  );
}
